import { ReceiptTemplate, ReceiptItem } from '@baemingo/receipt';
import { GetVenueMetadata_Venue_receiptTemplate } from '~Hooks/__queries__';
import { CardDetails, StaffIDState } from '~reducers';
import { i18nProps, TranslatedString } from '~Types';

export type Payment = { type: string; amount: string; tip?: string };

export enum ReceiptType {
  Sale = 'sale',
  Copy = 'copy',
  Refund = 'refund',
  Cheque = 'cheque',
  Invoice = 'invoice',
  TipRefund = 'tip_refund',
}

export interface Vars {
  [key: string]: string | undefined;
}

export type GenerateTemplateProps = (props: {
  type: ReceiptType;
  payments?: Payment[];
  cardDetails?: CardDetails;
  vars: Vars;
  isTable?: boolean;
  receiptTemplate: GetVenueMetadata_Venue_receiptTemplate;
  isTypeInvoice: boolean;
  items: ReceiptItem[];
  i18n: i18nProps;
  isCopy?: boolean;
  country?: string;
  showTipSuggestions?: boolean;
  showStaffName?: boolean;
  totalAmountLargeFont?: boolean;
  staff?: StaffIDState;
}) => ReceiptTemplate;
